
import { computed, ref } from '@nuxtjs/composition-api';
const errorMessages = new Map();


errorMessages.set('0007', 'Bruger navn eller kodeord er forkert');
errorMessages.set('0008', 'Adgangstoken eller bruger navn eller kodeord er forkert');
errorMessages.set('0010', 'Vi kan desværre ikke nogen eksisterende abonnementer og kan derfor ikke hjælpe dig online');
errorMessages.set('0011', 'Vi kan desværre ikke nogen eksisterende abonnementer og kan derfor ikke hjælpe dig online');
export default function useSubscription (appContext) {
  const hubbleClient = appContext.$hubble;

  if (!appContext || !hubbleClient) {
    throw new Error('You must provide the nuxt app context to use this composable');
  }
  // Why does the below code not work ???
  const findErrorMessage = (messageKey) => {
    return errorMessages.get(messageKey) || errorMessages.get('0007');
  }
  const error = ref({
    hasError: false,
    errorResponse: {},
    errorMessage: ''
  });

  // eslint-disable-next-line complexity
  const getSubscriptionList = async (accessToken, accessTokenType) => {
    if ((accessTokenType !== 'MIT_ID' && accessTokenType !== 'JWT' && accessTokenType !== 'UN_PW') || accessToken?.length < 1) {
      throw new Error('Only AccessTokenTypes of JWT and MIT_ID are allowed and you must pass an accessToken')
    }
    try {
      error.value.hasError = false

      if (accessTokenType === 'UN_PW') {
        const { userName, password } = accessToken;
        const response = await hubbleClient.subscriptions.getSubscriptions({ userName, password, accessTokenType });
        return response.data;
      } else {
        const response = await hubbleClient.subscriptions.getSubscriptions({ accessToken, accessTokenType });
        return response.data;
      }
    } catch (err) {
      error.value.hasError = true;
      error.value.errorResponse = err.response.data;
      error.value.errorMessage = findErrorMessage(error.value?.errorResponse?.errorCode)
      return error;
    }
  };
  const getMarketOffer = async (bundleId) => {
    const res = await hubbleClient.subscriptions.getMarketOffer(bundleId);
    return res.data;
  }
  return {
    getMarketOffer,
    getSubscriptionList,
    error: computed(() => error.value)
  }
}
